import React, { useCallback, useState, useEffect } from 'react';
import { carService } from '../../services/carService';
import GenericTable from "../GenericTable";
import { formatTimestamp } from '../../utils/formatDate';
import { getProgressStateText } from '../../utils/UITextStates';
import '../../style/modals/detailsOrderModal.css';

const VehicleDetails = ({ vehicleData, workshopID, onViewOrder }) => {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (vehicleData?.id && workshopID) {
            fetchVehicleOrders(vehicleData.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleData, workshopID]);

    const fetchVehicleOrders = async (vehicleId) => {
        setIsLoading(true);
        try {
            const data = await carService.getVehicleHistory(vehicleId, workshopID);
            setOrders(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error al obtener órdenes del vehículo: ', error);
            setOrders([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewOrder = useCallback((orderData) => {
        if (onViewOrder) {
            onViewOrder(orderData);
        }
    }, [onViewOrder]);

    const columnsOrders = React.useMemo(() => [
        { Header: 'No. Orden', accessor: 'id' },
        { 
            Header: 'Fecha Ingreso', 
            accessor: 'checkin_date',
            Cell: ({ value }) => value ? formatTimestamp(value) : 'N/A'
        },
        { Header: 'Servicio', accessor: 'services_request' },
        { 
            Header: 'Estado', 
            accessor: 'process_state',
            Cell: ({ value }) => getProgressStateText(value)
        },
        { Header: 'Total', accessor: 'total' },
        {
            Header: 'Acciones',
            accessor: 'acciones',
            Cell: ({ row }) => (
                <span
                    className='action-text'
                    onClick={() => handleViewOrder(row.original)}
                >
                    Ver detalles
                </span>
            )
        }
    ], [handleViewOrder]);

    if (isLoading) {
        return (
            <div className="loading-container">
                <p>Cargando información del vehículo...</p>
            </div>
        );
    }

    return (
        <div className="vehicle-details-content">
            {/* Información del Vehículo */}
            <section className="vehicle-info-section">
                <h3>Información del Vehículo</h3>
                <div className="info-grid">
                    <div className="info-field">
                        <label>Marca:</label>
                        <span>{vehicleData.marca || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>Submarca:</label>
                        <span>{vehicleData.sub_marca || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>Modelo:</label>
                        <span>{vehicleData.modelo || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>Matrícula:</label>
                        <span>{vehicleData.matricula || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>Color:</label>
                        <span>{vehicleData.color || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>VIN:</label>
                        <span>{vehicleData.VIN || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>Motor:</label>
                        <span>{vehicleData.motor || 'N/A'}</span>
                    </div>
                    <div className="info-field">
                        <label>Transmisión:</label>
                        <span>{vehicleData.transmission || 'N/A'}</span>
                    </div>
                </div>
            </section>

            {/* Historial de Órdenes */}
            <section className="orders-section">
                <h3>Historial de Órdenes ({orders.length})</h3>
                {orders.length > 0 ? (
                    <GenericTable columns={columnsOrders} data={orders} />
                ) : (
                    <p className="no-data">No hay órdenes registradas para este vehículo.</p>
                )}
            </section>
        </div>
    );
};

export default VehicleDetails;
